import { defaultTheme } from '@3plearning/react-components';

export default {
  ...defaultTheme.colours,
  grey: {
    100: '#ffffff',
    200: '#eaf9f9',
    300: '#e6e9ea',
    400: '#c2c2c2',
    500: '#c3d5e1',
    600: '#94b4c9',
    700: '#94b4c9',
    800: '#3b4e5e',
    900: '#000000'
  },
  proficiency: {
    unassigned: '#fff',
    assigned: '#dae7d3',
    20: '#031c73',
    40: '#314eb5',
    60: '#0c8a03',
    80: '#0fc2a8',
    100: '#4bda40'
  },
  upf: {
    100: '#eaf9f9',
    200: '#c3d5e1',
    300: '#94b4c9',
    400: '#7fa7c2',
    500: '#3b4e5e',
    600: '#000'
  }
};
